import { useQuery } from "@tanstack/react-query";
import { Mail, MapPin, Clock, MessageSquare } from "lucide-react";
import api from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import { Reveal, SectionHead } from "@/components/site/Reveal";
import LeadForm from "@/components/site/LeadForm";

export default function Contact() {
  useSeo({ title: "Contact", description: "Get in touch with Buddy Solution to start a project, request a quote or ask a question." });
  const { data: services = [] } = useQuery({ queryKey: ["services"], queryFn: async () => (await api.get("/services")).data });

  return (
    <div className="bs-container py-16 lg:py-20">
      <Reveal><SectionHead center eyebrow="Contact" title="Let's talk about your project"
        subtitle="Tell us what you need and we'll respond with a clear plan and quote, usually within one business day." /></Reveal>

      <div className="mt-14 grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
        <Reveal>
          <div className="space-y-4">
            {[
              [Mail, "Email us", "hello@buddysolution.net"],
              [MapPin, "Where we work", "Worldwide / Remote-first"],
              [Clock, "Working hours", "Mon-Fri, 9am-6pm"],
              [MessageSquare, "Response time", "Typically within 1 business day"],
            ].map(([Ic, t, v]) => (
              <div key={t} className="flex items-start gap-4 bs-card p-5">
                <div className="rounded-xl bg-primary/12 p-2.5 text-primary"><Ic className="h-5 w-5" /></div>
                <div><p className="text-sm font-semibold">{t}</p><p className="text-sm text-muted-foreground">{v}</p></div>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="rounded-2xl border border-border bg-card p-6 sm:p-8">
            <LeadForm type="contact" services={services} submitLabel="Send message" />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
